/*
 * @desc: 
 * @author: mao
 * @version: 1.0
 * @Date: 2024-12-13 15:48:46
 */
import { HashRouter, Route, Routes } from "react-router-dom";
import ConsumeTitleHoc from "../hoc/ConsumeTitleHoc";
import Layout from "../views/Layout/Layout";
import Index from "../views/Index/Index";
const basename = process.env.NODE_ENV == "development" ? "/" : "/";

const HIndex = ConsumeTitleHoc(Index, "2025｜@国务院 我为政府工作报告提建议");
// const HMyAdvice = ConsumeTitleHoc(MyAdvice);
export default () => {
    return (
        <HashRouter basename={basename}>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route path="index" element={<HIndex />} />
                    {/* <Route path="my-advice" element={<HMyAdvice />} /> */}
                </Route>
            </Routes>
        </HashRouter>
    );
};
